import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

/*
  ng update @angular/cli@11 @angular/core@11 @angular/animations@11 @angular/cdk@11 @angular/common@11 @angular/compiler@11 @angular/forms@11 @angular/router@11 @angular/platform-browser@11 @angular/platform-browser-dynamic@11 @angular/material@11 ng-mat-select-infinite-scroll@3
  */
